import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type MatrixAccess = 'NONE' | 'VIEW' | 'FULL';

export interface RacPage {
  id: string;
  key: string;
  name: string;
  module: string;
  parentKey: string | null;
  sortOrder: number;
  allowedLocationTypes: string[];
}

export interface RacRole {
  id: string;
  name: string;
  isSuperUser: boolean;
}

export interface RacMatrix {
  pages: RacPage[];
  roles: RacRole[];
  grants: { roleId: string; pageId: string; access: 'VIEW' | 'FULL' }[];
  superUserRoles: string[];
}

@Injectable({ providedIn: 'root' })
export class RolesAccessService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/access-control`;

  getMatrix(): Observable<RacMatrix> {
    return this.http.get<RacMatrix>(`${this.base}/matrix`);
  }

  saveMatrix(
    roleId: string,
    entries: { pageKey: string; access: MatrixAccess }[]
  ): Observable<{ updated: number; revoked: number }> {
    return this.http.put<{ updated: number; revoked: number }>(
      `${this.base}/matrix`,
      { roleId, entries }
    );
  }

  updateLocationTypes(
    pageKey: string,
    allowedLocationTypes: string[]
  ): Observable<{ key: string; allowedLocationTypes: string[] }> {
    return this.http.patch<{ key: string; allowedLocationTypes: string[] }>(
      `${this.base}/pages/${encodeURIComponent(pageKey)}/location-types`,
      { allowedLocationTypes }
    );
  }

  createRole(name: string): Observable<{ id: string; name: string }> {
    return this.http.post<{ id: string; name: string }>(`${this.base}/roles`, {
      name,
    });
  }
}
